const serviceRoot = '/api/DeveloperAccess/';

export const DeveloperAccessEndpoints = {
  generateSubmittedPdf: () => `${serviceRoot}generateSubmittedPDF`,
  getBannerInfo: () => `${serviceRoot}getBannerInfo`,
  hasRequiredEnvironmentVariables: () => `${serviceRoot}hasRequiredEnvironmentVariables`,
  isUrlReachable: () => `${serviceRoot}isUrlReachable`,
  jpaFileMetadataSync: () => `${serviceRoot}jpaFileMetadataSync`,
  updateBannerStatus: () => `${serviceRoot}updateBannerStatus`,
  updateBannerText: () => `${serviceRoot}updateBannerText`,
  updateVersion: () => `${serviceRoot}updateVersion`,
  transferUserProjects: () => `${serviceRoot}transferUserProjects`,
};
